import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class SupplierMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.supplier.supplierMapperError"));

        Object.setPrototypeOf(this, SupplierMapperError.prototype);
    }
}